<div class="text-area" [ngClass]="state()" [class.auto-grow]="autoGrow()" [class.is-disabled]="disabled()">
  <div class="text-area-container">
    <textarea
      #textarea
      class="text-area-input"
      rows="2"
      [placeholder]="placeholder()"
      [(ngModel)]="value"
      [name]="name()"
      [disabled]="disabled()"
    ></textarea>
  </div>
  @if (alert()) {
    <div class="text-area-alert">
      <ui-inline-svg class="text-area-alert-icon" [name]="icon()"></ui-inline-svg>
      <span class="text-area-alert-text">{{ alert() }}</span>
    </div>
  }
</div>
